<template>
  <div>
    <ui-modal
      ref="modal"
      :title="`Detalles Late Arrival - ID : ${titulo}`"
      @close="actionSetVisibleModalInformacionGeneralLateArrival(false)"
      class="modal-informacion-late-arrivals"
      size="large"
      :header="false"
    >
      <!-- <pre>
      {{ data }}
    </pre
      > -->
      <!-- Primera Fila -->
      <div class="d-flex">
        <div class="w-100">
          <div class="Heading Cell">
            <p class="m-2">Número de Booking</p>
          </div>
          <div class="d-flex justify-content-center Cell">
            <p class="m-2" v-text="nroBookingModel"></p>
          </div>
        </div>
      </div>
      <!-- Segunda Fila -->
      <div class="d-flex">
        <div class="w-50">
          <div class="Heading Cell">
            <p class="m-2">Stacking To</p>
          </div>
          <div class="d-flex justify-content-center Cell">
            <p class="m-2" v-text="stackingTOModel"></p>
          </div>
        </div>
        <div class="w-50">
          <div class="Heading Cell">
            <p class="m-2">Stacking From</p>
          </div>
          <div class="d-flex justify-content-center Cell">
            <p class="m-2" v-text="stackingFROMModel"></p>
          </div>
        </div>
      </div>
      <br />
      <div>
        <data-table
          customHeaders
          :headers="headers"
          :data="dataDetalle"
          :acciones="accionesVer"
          :max="8"
          paginacion
          :seleccionar="obtenerFilaSeleccionada"
          :numerador="false"
        />
      </div>
    </ui-modal>
  </div>
</template>

<script>
// UI Modal
import UiModal from "keen-ui/src/UiModal";
// Common
// import HistorialAcciones from "../../../../common/HistorialAcciones";
// Vuex
import { mapState, mapActions } from "vuex";
// Constantes
import DataTable from "../../../../common/DataTable";
import {
  cambiarEstadoContenedorLateArrival,
  // getListarDetalleLateArrivals,
  // getHistorialLateArrivals
} from "../../../../../constants/lineas";

export default {
  props: [
    "data",
    "dataDetalle",
    "accionesVer",
    "dataInformacionGeneral",
    "verDetalleLateArrivals",
    "generarBotonesAccionesVerDetalle",
  ],
  data() {
    return {
      idBookingModel: "",
      nroBookingModel: "",
      stackingTOModel: "",
      stackingFROMModel: "",
      dataAux: this.data,
      acciones: [],
      headers: [
        { title: "Número de Contenedor", width: "30px" },
        { title: "Fecha de Solicitud", width: "30px" },
        { title: "Usuario Solicitante", width: "50px" },
        { title: "Estado", width: "50px" },
        { title: "Accion", width: "50px" },
      ],
      id_late: "",
      titulo: "",
    };
  },
  components: {
    UiModal,
    // HistorialAcciones,
    DataTable,
  },
  computed: {
    ...mapState("lineas", ["visibleModalInformacionGeneralLateArrival"]),
  },
  methods: {
    ...mapActions("lineas", [
      "actionSetVisibleModalInformacionGeneralLateArrival",
      "actionSetDatatableDetalleLateArrivals",
      // "actionSetIdAuxiliarBookingSeleccionado",
    ]),
    ...mapActions(["AccionCambiar", "ActionSetLoadingTable"]),
    // async generarBotonesAcciones() {
    //   let me = this;

    //   // console.log("probando data" + this.data.dataAux); -- undefined

    //   me.arregloAux.length > 0 &&
    //     (await me.arregloAux.map((item, index) => {
    //       let estado = item.dataAux;

    //       if (estado == "Pendiente") {
    //         me.acciones.push([
    //           {
    //             icon: "fa fa-check",
    //             title: "Confirmar Late Arrival",
    //             id: index,
    //           },
    //           {
    //             icon: "fa fa-ban",
    //             title: "Rechazar",
    //             id: index,
    //           },
    //           // {
    //           //   icon: "far fa-file-pdf",
    //           //   title: "-",
    //           //   id: index,
    //           // },
    //         ]);
    //       }
    //     }));

    //   me.ActionSetLoadingTable(false);
    // },

    obtenerFilaSeleccionada(fila) {
      // console.log(fila);
      //
      // let data_fila2 = this.data.data[fila.id];
      // console.log("data_fila2:: ", data_fila2);

      console.log("fila :: ", fila);
      let data_fila = this.dataDetalle[fila.id];
      this.id_late = this.dataDetalle[fila.id].data_complementaria.id;
      console.log("id late:: ", this.id_late);
      console.log("data_fila:: ", data_fila);
      // console.log("id late:: ", id_late);
      switch (fila.accion) {
        case "Confirmar Late Arrival":
          this.accepted = true;
          // this.actionSetDatatableDetalleLateArrivals(this.dataDetalle.data_table);
          console.log("Confirmar Late Arrival");
          this.$vToastify
            .prompt(
              `¿Desea Confirmar el Late Arrival del Nro Booking: ${this.nroBookingModel}?`
            )
            .then((respuesta) => respuesta && this.confirmarCancelar());

          break;

        case "Rechazar":
          this.accepted = false;
          // this.actionSetDatatableDetalleLateArrivals(this.dataDetalle.data_table);
          console.log("Rechazar");
          this.$vToastify
            .prompt(
              `¿Desea Rechazar el Late Arrival del Nro Booking: ${this.nroBookingModel}?`
            )
            .then((respuesta) => respuesta && this.confirmarCancelar());

          break;

        default:
          break;
      }
    },
    async confirmarCancelar() {
      const form = {
        id_late_arrival: this.id_late,
        accepted: this.accepted,
      };
      console.log("id_late :: ", this.id_late);
      console.log("accepted :: ", this.accepted);
      const data = await cambiarEstadoContenedorLateArrival(form);
      console.log("data cambiar estado :: ", data);

      console.log("this.itinerary_id :>>: ", this.itinerary_id);
      await this.verDetalleLateArrivals(this.itinerary_id);

      await this.generarBotonesAccionesVerDetalle();
      // let data_aux = await getListarDetalleLateArrivals(this.itinerary_id);

      // this.datita = data_aux.data_table;

      // console.log("data_aux :: ", data_aux);

      // this.actionSetDatatableDetalleLateArrivals(this.dataDetalle.data_table);

      // this.actionSetDatatableDetalleLateArrivals(data_aux.data_table);

      // return response;
    },
    openModal(ref) {
      this.$refs[ref].open();
    },

    closeModal(ref) {
      this.$refs[ref].close();
    },
  },

  watch: {
    visibleModalInformacionGeneralLateArrival: function (_new) {
      if (_new) {
        this.openModal("modal");
      }
    },
    data: function (_new) {
      let me = this;
      if (_new) {
        me.dataAux = _new;
        this.titulo = _new.data[0];
        console.log(_new.data[0]);
        this.idBookingModel = _new.data[0];
        this.stackingTOModel = _new.data_complementaria[3];
        this.stackingFROMModel = _new.data_complementaria[2];
        this.nroBookingModel = _new.data[8];
        this.itinerary_id = _new.data_complementaria[4];
        // this.generarBotonesAcciones();
      }
      // console.log(_new.dataDetalle);
      // this.dataDetalle = _new.data_complementaria[4];
    },
    // dataDetalle: function (_new) {
    //   let me = this;
    //   if (_new) {
    //     me.dataAux = _new;
    //     // this.generarBotonesAcciones();
    //   }
    //   this.stackingTOModel = _new.data_complementaria[3];
    //   this.stackingFROMModel = _new.data_complementaria[2];
    //   this.nroBookingModel = _new.data[8];
    // },
  },
};
</script>
<style>
.modal-informacion-late-arrivals .ui-modal__container {
  width: 100% !important;
  margin-top: 70px !important;
}
.Heading {
  background-color: #ccccca;
  font-weight: bold;
  text-align: center;
}

.Cell {
  border: groove;
  border-width: thin;
}
</style>
